import { EditableText, Icon } from '@salecycle/ui-component-library';
import { useMemo, useState } from 'react';
import { useCampaignEditorContext } from '../state/hooks/useCampaignEditorContext';
import { useSetCampaignName } from '../state/actions/useSetCampaignName';
import { useTranslation } from 'react-i18next';

export const CampaignNameInput = () => {
  const { t } = useTranslation('campaigns');

  const { state } = useCampaignEditorContext();
  const setName = useSetCampaignName();

  const [focusMode, setFocusMode] = useState(false);

  const campaignNameValidationState: { message: string; status: 'warning' | 'complete' } = useMemo(() => {
    const minAllowedChar = 5;
    const maxAllowedChar = 100;
    if (
      (state.campaign.name?.length > 0 && state.campaign.name?.length < minAllowedChar) ||
      state.campaign.name?.length > maxAllowedChar
    ) {
      return {
        message: t('bulkRetargetingCampaigns.editor.campaignNameValidationMessage'),
        status: 'warning',
      };
    }

    return {
      message: null,
      status: 'complete',
    };
  }, [state.campaign.name?.length, t]);

  return (
    <EditableText
      style={{ backgroundColor: 'unset' }}
      ariaLabel={t('bulkRetargetingCampaigns.editor.campaignNameAria')}
      value={state.campaign.name}
      onChange={setName}
      placeholder={t('bulkRetargetingCampaigns.editor.campaignNamePlaceholder')}
      darkMode={true}
      Icon={<Icon icon="edit" color={'#586874'} />}
      onFocus={() => setFocusMode(true)}
      onBlur={() => setFocusMode(false)}
      maxLength={100}
      focusMode={focusMode}
      spacingBelow={false}
      hasCharCount={true}
      minWidth={'315px'}
      maxWidth={'315px'}
      disabled={state.status === 'TRIGGERED' || state.status === 'SCHEDULED'}
      charLength={focusMode && state.campaign.name?.length}
      validationMessage={!focusMode ? campaignNameValidationState.message : ''}
      validationState={focusMode && campaignNameValidationState.status}
    />
  );
};
